import { useContext } from 'react'
import { WebSocketContext } from './websocket-context.js'

export const useWebSocket = () => {
  const socket = useContext(WebSocketContext)
  return socket
}
